import { number } from "yup";
import { SessionDurationValues } from "../../consts";

export const SessionDurationValidation = number().oneOf(SessionDurationValues);
